import { IPublicClientApplication, AccountInfo } from '@azure/msal-browser'
import { logoutIntercom } from 'src/services/intercom'

import { tokenRequest } from './config'

let tokenRefreshPromise: Promise<string | null> | null = null

// MSAL returns the cached token while it is valid and refreshes it silently otherwise;
// concurrent callers share one request, and an expired session logs the user out
export const getAccessToken = async (
  instance: IPublicClientApplication,
  account: AccountInfo | undefined,
): Promise<string | null> => {
  if (!account) {
    console.warn(' No active account found')
    return null
  }

  if (tokenRefreshPromise) {
    return tokenRefreshPromise
  }

  tokenRefreshPromise = instance
    .acquireTokenSilent({
      ...tokenRequest,
      account,
    })
    .then(response => {
      localStorage.setItem('accessToken', response.accessToken)

      return response.accessToken
    })
    .catch(async error => {
      console.log('Session expired. Logging out.', error)
      tokenRefreshPromise = null
      logoutIntercom()
      localStorage.clear()
      await instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      })

      return null
    })
    .finally(() => {
      tokenRefreshPromise = null
    })
  return tokenRefreshPromise
}
